import React, { useEffect, useState } from 'react';
import { StoreProvider } from '../../store/storeUtils';
import { ApolloProvider } from '@apollo/client';
import { create } from 'mobx-persist';
import Store from '../../store/store';
import GraphqlClient from '../../client/GraphqlClient';
import CMSContextProvider from './CMSContextProvider';
const hydrate = create({});
const store = new Store();
const CMSNeurosalesWrapper = props => {
  const [content, setContent] = useState(null);
  useEffect(() => {
    hydrate('store_cms', store).then(() => {
      if (props.setPreviewConfiguration) {
        store.setToolSetPreviewConfiguration(props.setPreviewConfiguration);
      }
      if (props.projectInfo) {
        store.setProjectInfo({
          ...props.projectInfo
        });
      }
      if (props.forceUpdate) {
        store.setForceUpdate(props.forceUpdate);
      }
      let updateConfig = false;
      if (!props.localDevelopment) {
        if (!store.previewConfiguration) {
          updateConfig = true;
        } else if (store.projectId !== props.projectInfo.id) {
          updateConfig = true;
        }
      }
      if (props.baseUrl) {
        store.setBaseUrl(props.baseUrl);
      }
      if (updateConfig) {
        const defaultConfiguration = {
          configuration: props.defaultConfiguration
        };
        store.setRenderPreviewConfiguration(defaultConfiguration);
        store.synchronizeWholeConfiguration();
      }
      setContent( /*#__PURE__*/React.createElement(StoreProvider, {
        value: store
      }, /*#__PURE__*/React.createElement(ApolloProvider, {
        client: GraphqlClient(store)
      }, /*#__PURE__*/React.createElement(CMSContextProvider, props))));
    });
    return () => {};
  }, [props]);
  return content;
};
export default CMSNeurosalesWrapper;